import {MatTabChangeEvent, MatTabContent, MatTabGroup} from "@angular/material/tabs";
import {AppStateService} from '../../service/app-state.service';
import { Directive } from '@angular/core';

@Directive()
export abstract class TabDetailComponent {

  selectedTabIndex = 0;
  tabName: string = '';

  constructor(protected appStateService: AppStateService) {
    const selectedTabIndex = appStateService.getSelectedTabIndex(this.tabName);
    if (selectedTabIndex) {
      this.selectedTabIndex = appStateService.getSelectedTabIndex(this.tabName);
    }
  }

  selectedIndexChange(e: MatTabChangeEvent) {
    this.appStateService.setSelectedTabIndex(this.tabName, e.index);
  }
}
